import { render, staticRenderFns } from "./comentarios -pagos.vue?vue&type=template&id=2faeae18&scoped=true&"
import script from "./comentarios -pagos.vue?vue&type=script&lang=js&"
export * from "./comentarios -pagos.vue?vue&type=script&lang=js&"
import style0 from "./comentarios -pagos.vue?vue&type=style&index=0&id=2faeae18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faeae18",
  null
  
)

export default component.exports